import React from "react";
import "./App.css";
import axios from "axios";
import styled from "styled-components";
import { connect } from "react-redux";
import {
  IStateType,
  IDispatchType,
  VideoState,
  YoukuVideo,
  StudyVideo,
  StudyResult,
} from "./types";
import {
  initServer,
  fetchDemoVideo,
  fetchYoukuVideo,
  fetchStudyVideo,
} from "./store/actions";
// Utils
import { consoleError } from "./utils/logger";
import { Button, Select, Result, Radio, Row, Col, Space, Alert } from "antd";
// Components
import VideoTracker from "./components/VideoTracker";
import FrameBrowser from "./components/FrameBrowser";
import AudioStoryline from "./components/AudioStoryline";
// Demo data
import videoAlgJson from "../public/dataset/0000.alg.json";
import audioAlgJson from "../public/dataset/0000.story.json";
import imageAlgJson from "../public/dataset/0000.tsne.json";

const mapStateToProps = (state: IStateType) => {
  return {
    videoState: state.videoState,
    videoSrc: state.videoState.videoSrc,
    videoRiskTS: state.videoState.videoRiskTS,
    videoFrames: state.videoState.videoFrames,
    videoASRText: state.videoState.videoASRText,
    audioScript: state.videoState.audioScript,
    riskColorMap: state.videoState.riskColorMap,
    participants: state.studyState.participants,
    videoIds: state.studyState.videoIds,
    videoLabels: state.studyState.videoLabels,
    videoOrders: state.studyState.videoOrders,
  };
};

const mapDispatchToProps = (dispatch: IDispatchType) => {
  return {
    initServer: (msg: string) => dispatch(initServer(msg)),
    fetchDemo: (videoInfo: VideoState) => dispatch(fetchDemoVideo(videoInfo)),
    fetchYouku: (videoInfo: YoukuVideo) => dispatch(fetchYoukuVideo(videoInfo)),
    fetchStudy: (videoInfo: StudyVideo) => dispatch(fetchStudyVideo(videoInfo)),
  };
};

const colorScheme = [
  {
    risk: "FA",
    policy: "Flase Advertising",
    color: "#fb8072",
    borderColor: "#fa574b",
  },
  {
    risk: "PP",
    policy: "Protected Products",
    color: "#80b1d3",
    borderColor: "#4698c7",
  },
  {
    risk: "IB",
    policy: "Inappropriate Business",
    color: "#fdb462",
    borderColor: "#f7953c",
  },
  {
    risk: "SC",
    policy: "Sensitive content",
    color: "#8dd3c7",
    borderColor: "#538e82",
  },
  {
    risk: "NM",
    policy: "Normal",
    color: "#c0c0c0",
    borderColor: "#999999",
  },
];

const AppHeader = styled.div`
  width: 100%;
  height: 56px;
  display: flex;
  flex-direction: row;
  margin-bottom: 10px;
  box-shadow: 0 4px 8px rgba(32, 84, 159, 0.4);
`;

const AppContent = styled.div`
  width: 100%;
  padding: 0 4px;
`;

const CompContainer = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 5px;
  box-shadow: 2px 2px 4px rgba(32, 84, 159, 0.4);
`;

const CompHeader = styled.div`
  width: 100%;
  height: 36px;
  padding: 0 0 0 16px;
  line-height: 36px;
  background: #fafafa;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  box-shadow: 0 2px 4px rgba(32, 84, 159, 0.4);
`;

const CompWrapper = styled.div`
  width: 100%;
  border-top: 1px solid #bfbfbf;
  border-radius: 5px;
`;

type State = {
  interface: string;
  currentTime: number;
  userId: string;
  videoId: string;
  videoLabel: string;
  videoOrder: number[];
  videoOrderIdx: number;
  isFinished: boolean;
  isWarning: boolean;
  startTimestamp: number;
  result: StudyResult[];
  btnLabel: string;
};

type Props = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps>;

function getTimeNow() {
  return new Date().getTime();
}

class App extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      interface: "A",
      currentTime: 0,
      userId: "P1",
      videoId: "0000",
      videoLabel: "正常",
      videoOrder: [],
      videoOrderIdx: -1,
      isFinished: false,
      isWarning: false,
      startTimestamp: getTimeNow(),
      result: [],
      btnLabel: "Normal",
    };
  }

  componentDidMount() {
    this.test();
  }

  changeUserId(userId: string) {
    if (this.props.videoOrders.has(userId)) {
      const videoOrder = this.props.videoOrders.get(userId);
      this.setState({
        userId: userId,
        currentTime: 0,
        videoOrder: videoOrder,
        videoOrderIdx: -1,
      });
    }
  }

  changeVideoTime(currentTime: number) {
    this.setState({ currentTime: currentTime });
  }

  changeVideoLabel(label) {
    this.setState({ videoLabel: label });
  }

  changeLabelTest(label) {
    this.setState({ btnLabel: label });
  }

  fetchVideo(videoId) {
    axios
      .post(`/api/study1_dataset`, { videoId: videoId })
      .then((res) => {
        const resData = res.data as StudyVideo;
        this.props.fetchStudy(resData);
      })
      .catch((err) => {
        consoleError(err);
      });
  }

  fetchLocalVideo() {
    this.props.fetchStudy({
      videoId: "0000",
      videoSrc: "dataset/0000.mp4",
      videoAlgJson: videoAlgJson,
      audioAlgJson: audioAlgJson,
      imageSrc: "dataset/0000.vi",
      imageAlgJson: imageAlgJson,
    });
  }

  downloadResult() {
    console.log(this.state.result);
    const ret = {};
    const retKey = `${this.state.interface}-${this.state.userId}`;
    ret[retKey] = this.state.result;
    const datastr =
      "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(ret));
    const downloadAnchorNode = document.createElement("a");
    downloadAnchorNode.setAttribute("href", datastr);
    downloadAnchorNode.setAttribute("download", `${retKey}.json`);
    downloadAnchorNode.click();
    downloadAnchorNode.remove();
  }

  start() {
    const { userId } = this.state;
    if (this.props.videoOrders.has(userId)) {
      const videoOrder = this.props.videoOrders.get(userId);
      const videoId = this.props.videoIds[videoOrder[0]];
      this.fetchVideo(videoId);
      this.setState({
        currentTime: 0,
        userId: userId,
        videoId: videoId,
        videoLabel: "正常",
        videoOrder: videoOrder,
        videoOrderIdx: 0,
        isFinished: false,
        isWarning: false,
        startTimestamp: getTimeNow(),
        result: [],
      });
    }
  }

  test() {
    // this.fetchVideo("0000");
    this.fetchLocalVideo();
    this.setState({
      currentTime: 0,
      isFinished: false,
      isWarning: false,
    });
  }

  next() {
    const { videoIds } = this.props;
    const {
      userId,
      videoId,
      videoOrderIdx,
      videoOrder,
      videoLabel,
      startTimestamp,
      currentTime,
    } = this.state;
    if (videoOrder.length === 0) {
      this.setState({ isWarning: true });
      return;
    }
    const currentTimestamp = getTimeNow();
    const duration = currentTimestamp - startTimestamp;
    console.log(userId, videoId, videoLabel, duration, currentTime);
    this.state.result.push({
      interface: this.state.interface,
      userId: userId,
      videoId: videoId,
      videoLabel: videoLabel,
      duration: duration,
      evidance: currentTime,
    });
    if (videoOrderIdx < videoOrder.length - 1) {
      const nextVideoId = videoIds[videoOrder[videoOrderIdx + 1]];
      this.fetchVideo(nextVideoId);
      this.setState({
        currentTime: 0,
        videoId: nextVideoId,
        videoLabel: "正常",
        videoOrderIdx: videoOrderIdx + 1,
        startTimestamp: currentTimestamp,
      });
    } else {
      this.downloadResult();
      this.setState({
        currentTime: 0,
        isFinished: true,
        startTimestamp: currentTimestamp,
        result: [],
      });
    }
  }

  render(): JSX.Element {
    const { btnLabel } = this.state;
    const riskLabelBtns = colorScheme.map((item) => (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          margin: "0 5px",
        }}
      >
        <div
          style={{
            width: "30px",
            height: "30px",
            borderRadius: "8px",
            border: `4px solid ${item.borderColor}`,
            background: item.color,
            marginRight: "5px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          onClick={() => this.changeLabelTest(item.policy)}
        >
          {btnLabel === item.policy && (
            <div
              style={{
                width: "12px",
                height: "12px",
                borderRadius: "2px",
                background: item.borderColor,
              }}
            />
          )}
        </div>
        <span style={{ fontSize: 16, fontWeight: 500 }}>{item.policy}</span>
      </div>
    ));
    const AppTitle = (
      <AppHeader>
        <div
          style={{
            background: "#4f5d75",
            width: "20vw",
            height: "100%",
            color: "white",
            fontSize: "28px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <b>VideoModerator</b>
        </div>
        <div
          style={{
            width: "0",
            height: "0",
            borderLeft: "28px solid #4f5d75",
            borderTop: "28px solid #4f5d75",
            borderRight: "28px solid transparent",
            borderBottom: "28px solid transparent",
          }}
        ></div>
        <div
          style={{
            position: "absolute",
            width: "100%",
            height: "5px",
            background: "#4f5d75",
          }}
        ></div>
        <div
          style={{
            flex: "auto",
            height: "100%",
            display: "flex",
            flexDirection: "row-reverse",
            alignItems: "center",
          }}
        >
          <div
            className={"clickBtn"}
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              margin: "0px 20px 0px 10px",
              width: "100px",
              height: "30px",
              borderRadius: "15px",
            }}
          >
            <img
              src={require("./submit.png")}
              style={{
                width: "25px",
                height: "25px",
                marginLeft: "2px",
              }}
            />
            <span
              style={{
                fontSize: 16,
                fontWeight: 500,
                color: "#fff",
                marginLeft: "10px",
              }}
            >
              Submit
            </span>
          </div>
          {riskLabelBtns}
          <div
            className={"clickBtn"}
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              margin: "0px 10px",
              borderRadius: "15px",
              width: "100px",
              height: "30px",
            }}
          >
            <img
              src={require("./load.png")}
              style={{
                width: "29px",
                height: "29px",
              }}
            />
            <span
              style={{
                fontSize: 16,
                fontWeight: 500,
                color: "#fff",
                marginLeft: "24px",
              }}
            >
              Load
            </span>
          </div>
        </div>
      </AppHeader>
    );
    const VideoView = (
      <CompContainer style={{ background: "white" }}>
        <CompHeader>
          <b style={{ color: "#666", fontSize: "16px" }}>Video View</b>
        </CompHeader>
        <CompWrapper style={{ height: "84vh" }}>
          <VideoTracker
            videoSrc={this.props.videoSrc}
            videoType={"video/mp4"}
            videoWidth={540}
            videoHeight={960}
            videoRisk={this.props.videoRiskTS}
            videoText={this.props.videoASRText}
            videoStartTime={this.state.currentTime}
          />
        </CompWrapper>
      </CompContainer>
    );
    const FrameView = (
      <CompContainer>
        <CompHeader>
          <b style={{ color: "#666", fontSize: "16px" }}>Frame View</b>
        </CompHeader>
        <CompWrapper style={{ height: "50vh" }}>
          <FrameBrowser
            data={this.props.videoFrames}
            risk={this.props.videoRiskTS}
            color={this.props.riskColorMap}
            setCurrentVideoTime={(videoTime: number) =>
              this.changeVideoTime(videoTime)
            }
          />
        </CompWrapper>
      </CompContainer>
    );
    const AudioView = (
      <CompContainer>
        <CompHeader>
          <b style={{ color: "#666", fontSize: "16px" }}>Audio View</b>
        </CompHeader>
        <CompWrapper style={{ height: "33vh" }}>
          <AudioStoryline
            audioScript={this.props.audioScript}
            riskColorMap={this.props.riskColorMap}
            setCurrentVideoTime={(videoTime: number) =>
              this.changeVideoTime(videoTime)
            }
          />
        </CompWrapper>
      </CompContainer>
    );
    return (
      <div className="App">
        {AppTitle}
        <AppContent>
          <Row gutter={[8, 0]}>
            <Col span={7}>{VideoView}</Col>
            <Col span={17}>
              <Row gutter={[0, 8]}>
                <Col span={24}>{FrameView}</Col>
              </Row>
              <Row>
                <Col span={24}>{AudioView}</Col>
              </Row>
            </Col>
          </Row>
        </AppContent>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(App);
